import { useState } from "react";
import pluralize from "~/kernel/strings/pluralize";
import className from "~/kernel/styling/className";
import FieldError from "./FieldError";
import Icon from "./Icon";
import Label from "./Label";
import range from "~/kernel/arrays/range";
import MIN_SCORE from "~/constants/review/MIN_SCORE";
import MAX_SCORE from "~/constants/review/MAX_SCORE";

export const AVAILABLE_SCORES = range(MIN_SCORE, MAX_SCORE);

type Props = {
  error?: string;
  required?: boolean;
  defaultValue?: number;
  readOnly?: boolean;
  size?: "regular" | "small";
};

export default function StarInput({
  required,
  error,
  defaultValue = 0,
  readOnly,
  size = "regular",
}: Props) {
  const [selectedScore, setSelectedScore] = useState(defaultValue);

  return (
    <div className="space-y-2">
      {readOnly ? null : (
        <div className="block">
          <Label id="score" label="Betyg" required={required} />
        </div>
      )}
      <div>
        {AVAILABLE_SCORES.map((score) => {
          return (
            <label key={score} className="relative">
              <input
                key={score}
                aria-label={`${score} ${pluralize(
                  score,
                  " stjärna",
                  "stjärnor",
                )}`}
                name="score"
                type="radio"
                defaultValue={score}
                className="peer absolute h-full w-full opacity-0"
                readOnly={readOnly}
                disabled={readOnly}
                onChange={(ev) => {
                  if (ev.target.checked) {
                    setSelectedScore(score);
                  }
                }}
              />
              <Icon
                name="star"
                className={className("peer-checked:text-yellow-500", {
                  "text-2xl": size === "regular",
                  "text-base": size === "small",
                  "text-yellow-500": score <= selectedScore,
                  "text-slate-200": score > selectedScore,
                })}
              />
            </label>
          );
        })}
      </div>
      <FieldError error={error} />
    </div>
  );
}
